// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './store'
import storeLocal from 'store';
import moment from 'moment';
import getErrorMsg from '@/language/getErrorMessage';
import 'babel-polyfill'
import './assets/style/resrt.css'
import './assets/style/wm_blue.css'
import './assets/style/main.css'
import './assets/style/animate.css'
import './assets/js/live_animate.js'
import ElementUI, {
  Alert,
  Autocomplete,
  Backtop,
  Badge,
  Breadcrumb,
  BreadcrumbItem,
  Button,
  ButtonGroup,
  Calendar,
  Card,
  Carousel,
  CarouselItem,
  Cascader,
  CascaderPanel,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Col,
  Collapse,
  CollapseItem,
  ColorPicker,
  Container,
  DatePicker,
  Dialog,
  Divider,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Footer,
  Form,
  FormItem,
  Header,
  Icon,
  Image,
  Input,
  InputNumber,
  Link,
  Loading,
  Main,
  Menu,
  MenuItem,
  MenuItemGroup,
  Message,
  MessageBox,
  Notification,
  Option,
  OptionGroup,
  PageHeader,
  Pagination,
  Popover,
  Progress,
  Radio,
  RadioButton,
  RadioGroup,
  Rate,
  Row,
  Select,
  Slider,
  Spinner,
  Step,
  Steps,
  Submenu,
  Switch,
  Table,
  TableColumn,
  TabPane,
  Tabs,
  Tag,
  Timeline,
  TimelineItem,
  TimePicker,
  TimeSelect,
  Tooltip,
  Transfer,
  Tree,
  Upload
} from 'element-ui'
import VueI18n from "vue-i18n"
import {getConfigLanguage} from "@/utils/utils";
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale';
//element-ui自带多语言配置
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
import enLocale from 'element-ui/lib/locale/lang/en';
import hkLocale from 'element-ui/lib/locale/lang/zh-TW';
//页面中自定义变量
import cn from '@/vueI18n/cn';
import en from '@/vueI18n/en';
import hk from '@/vueI18n/hk';
import App from './App'
import router from './router'

Vue.use(VueI18n);
Vue.use(ElementUI);
Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Autocomplete);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Switch);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Button);
Vue.use(ButtonGroup);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(DatePicker);
Vue.use(TimeSelect);
Vue.use(TimePicker);
Vue.use(Popover);
Vue.use(Tooltip);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Tag);
Vue.use(Tree);
Vue.use(Alert);
Vue.use(Slider);
Vue.use(Icon);
Vue.use(Row);
Vue.use(Col);
Vue.use(Upload);
Vue.use(Progress);
Vue.use(Spinner);
Vue.use(Badge);
Vue.use(Card);
Vue.use(Rate);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Cascader);
Vue.use(ColorPicker);
Vue.use(Transfer);
Vue.use(Container);
Vue.use(Header);
// Vue.use(Aside);
Vue.use(Main);
Vue.use(Footer);
Vue.use(Timeline);
Vue.use(TimelineItem);
Vue.use(Link);
Vue.use(Divider);
Vue.use(Image);
Vue.use(Calendar);
Vue.use(Backtop);
Vue.use(PageHeader);
Vue.use(CascaderPanel);

Vue.use(Loading.directive);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;
Vue.config.productionTip = false;
Vue.prototype.$EventBus = new Vue();
Vue.prototype.$moment = moment;
Vue.prototype.$GetErrorMsg = getErrorMsg;
// 全局点击函数
Vue.prototype.$globalClick = function (callback, scopeId, excludeId) {
    document.getElementById(scopeId).onclick = function () {
        callback();
    };
    if (typeof excludeId === 'string') {
        document.getElementById(excludeId).onclick = function (e) {
            e.stopPropagation();
        };
    } else {
        excludeId.forEach((item, index) => {
            document.getElementById(item).onclick = function (e) {
                e.stopPropagation();
            };
        })
    }
};

// 定义挂载多语言文件
const configLanguage = getConfigLanguage();
const i18n = new VueI18n({
  locale: configLanguage || 'cn',
  // messages: {
  //   cn: require("@/vueI18n/cn"),
  //   en: require("@/vueI18n/en"),
  //   hk: require("@/vueI18n/hk"),
  // },
  messages: {
    cn: {...cn, ...zhLocale},
    en: {...en, ...enLocale},
    hk: {...hk, ...hkLocale},
  },
});
locale.i18n((key, value) => i18n.t(key, value)); //兼容element

const whiteList = ['/login', '/error', '/changePw', '/auditList', '/info'];// 不重定向白名单

// router.beforeEach((to, from, next) => {
//   // console.log(store.getters)
//   if (to.path !== '/login') {
//     if (storeLocal.get('Pwm-Islogin')) { // 判断是否登录
//       next()
//     } else {
//       if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
//         next()
//       } else {
//                 next('/login'); // 否则全部重定向到登录页
//             }
//         }
//     } else {
//         next()
//     }
// });

/* eslint-disable no-new */
new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js